<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Mehr als nur ein Aufstieg</h2>
        <div class="flex justify-center">
          <h1 class="headline">Innentreppen</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Eine Treppe ist weit mehr als nur ein funktionales Bauteil. Sie verbindet Etagen und oft auch Stile, Materialien und Menschen. Sie kann zurückhaltend sein oder ein architektonisches Statement setzen. In jedem Fall ist sie ein zentrales Element im Innenraum und genau so behandeln wir sie auch.
        </p>

        <p class="mt-4 text-gray-700">
          Ob als klassische Wangentreppe, gerade, gewendelt oder sogar gebogen, oder als filigrane Holmtreppe: Jede unserer Innentreppen entsteht individuell nach Ihren Vorstellungen. Auf Wunsch mit durchgängigen Ganzblechgeländern für eine klare, moderne Linie oder mit offenen Konstruktionen, die Leichtigkeit und Transparenz schaffen.
        </p>

        <p class="mt-4 text-gray-700">
          Bei der Wahl der Stufen setzen wir auf hochwertige Holzbeläge oder gekantete Blechstufen, die Sie ganz nach Wunsch weiterverkleiden können. Das macht unsere Treppen nicht nur anpassungsfähig, sondern auch besonders langlebig.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Innentreppen" pixelEvent="FormInnentreppenSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/innentreppen/1.jpg", alt: "Innentreppe 1" },
        { src: "img/produkte/innentreppen/2.jpg", alt: "Innentreppe 2" },
        { src: "img/produkte/innentreppen/3.jpg", alt: "Innentreppe 3" },
        { src: "img/produkte/innentreppen/4.jpg", alt: "Innentreppe 4" },
        { src: "img/produkte/innentreppen/5.jpg", alt: "Innentreppe 5" },
        { src: "img/produkte/innentreppen/6.jpg", alt: "Innentreppe 6" },
        { src: "img/produkte/innentreppen/7.jpg", alt: "Innentreppe 7" },
        { src: "img/produkte/innentreppen/8.jpg", alt: "Innentreppe 8" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
